import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { autoRehydrate } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import rootReducer from './rootReducer';

// Create a history of your choosing (we're using a browser history in this case).
export const history = createHistory();

export const saveType = {
  Add: 'add',
  Update: 'update'
}

history.listen((location, action) => {
  window.scrollTo(0, 0);
});

export const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  undefined,
  composeEnhancers(
    applyMiddleware(
      apiMiddleware,
      sagaMiddleware,
      routerMiddleware(history)
    ),
    autoRehydrate()
  )
);

export default store;



// WEBPACK FOOTER //
// ./src/state/store.js